import PropTypes from 'prop-types';
import classNames from 'classnames';
import { trans } from '@spotahome/soyuz/client';

import Collapsible from '../Collapsible';

import styles from './ValuePropositionFeatures.module.scss';

const defaultRenderBody = () => null;

const Feature = ({
  collapsed = true,
  onCollapsedChange = () => {},
  featureName,
  renderBody = null,
  renderIcon,
  renderHeader = null,
  headerKey,
  renderTitleIcon = () => {},
  isDangerState = false
}) => {
  const headerClassName = classNames(
    styles['booknow-card-features__item-title'],
    {
      [styles['booknow-card-features__item-title--state-danger']]: isDangerState
    }
  );

  const handleCollapsedChange = isClosed => {
    onCollapsedChange(featureName, isClosed);
  };

  return (
    <li
      className={styles['booknow-card-features__item']}
      data-test={`${featureName}-vp`}
    >
      <Collapsible
        hasIcon={!!renderBody}
        isCollapsed={collapsed}
        onCollapsedChange={handleCollapsedChange}
        isControlled
        inlineTitle
        className=""
        renderHeader={() => (
          <div className={headerClassName}>
            <span className={styles['booknow-card-features__item-icon']}>
              {renderIcon()}
            </span>
            {renderHeader ? (
              renderHeader(styles['booknow-card-features__item-title-text'])
            ) : (
              <span
                className={styles['booknow-card-features__item-title-text']}
              >
                {trans(headerKey)}
                {renderTitleIcon()}
              </span>
            )}
          </div>
        )}
        renderBody={() => (
          <div className={styles['booknow-card-features__item-body']}>
            {renderBody ? renderBody() : defaultRenderBody()}
          </div>
        )}
        iconTheme="dark"
      />
    </li>
  );
};

Feature.propTypes = {
  collapsed: PropTypes.bool,
  onCollapsedChange: PropTypes.func,
  featureName: PropTypes.string.isRequired,
  renderBody: PropTypes.func,
  renderHeader: PropTypes.func,
  renderIcon: PropTypes.func.isRequired,
  headerKey: PropTypes.string.isRequired,
  renderTitleIcon: PropTypes.func,
  isDangerState: PropTypes.bool
};

export default Feature;
